import { DomainDto } from '../../dtos/domain'

export enum AiView {
    OVERVIEW = 'overview',
    BRAND_VOICE = 'brand-voice',
    CURATOR = 'curator',
    PAGE_ANALYSIS = 'page-analysis',
}

export const DEFAULT_AI_VIEW = AiView.OVERVIEW

export const AI_VIEW_LABELS: Record<AiView, string> = {
    [AiView.OVERVIEW]: 'Overview',
    [AiView.BRAND_VOICE]: 'Brand Voice',
    [AiView.CURATOR]: 'Curator',
    [AiView.PAGE_ANALYSIS]: 'Page Analysis',
}

export const isAiView = (value: string): value is AiView => (Object.values(AiView) as string[]).includes(value)

/** Said once on the Curator view, so the two wells below it can stay specific. */
export const CURATOR_DESCRIPTION =
    'Every audience gets the story it is most likely to open, chosen from your own library and scored against ' +
    'what that segment has actually clicked. Set it once on a journey step and each send picks itself, so one ' +
    'campaign lands differently for readers with different interests.'

export const HEALTH_DESCRIPTION =
    'How much of this domain the Curator can actually draw on: which segments have enough click history to be ' +
    'scored against, and how much of the library carries the embeddings it ranks with.'

/**
 * These live on the journey step today, not on the domain, so the well reports
 * them and says where to change them.
 */
export const STEP_DEFAULTS_DESCRIPTION =
    'What a new Curator step starts from. Each step can widen any of these for itself, and changing one there ' +
    'does not affect steps that are already running.'

/**
 * Each service is gated separately, and FEAT_PUSHLY_AI additionally gates the
 * suite: without it there is nothing here a customer can configure.
 */
export const domainHasFlag = (domain: DomainDto | undefined, flag: string): boolean =>
    domain?.flags?.includes(flag) ?? false
